<template>
<div class="promo-swiper">
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,i) in items" :key="i">
                <div class="swiper-slide__img-holder">
                    <img class="img-fluid" :src="item.src" alt="">
                </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
export default {
    name: "Carousel",
    data() {
        return {
            items: [
                {
                    src: require('../assets/promos/image-1.jpg')
                },
                {
                    src: require('../assets/promos/image-1.jpg')
                },
                {
                    src: require('../assets/promos/image-1.jpg')
                }
            ]
        }
    },
    props: {
        msg: String
    },
    methods: {},
    mounted() {
        let swiper = new Swiper(".swiper-container", {
            slidesPerView: 1,
            // spaceBetween: 16,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
};
</script>

<style lang="scss">
.promo-swiper {
    position: relative;
    padding: 0;
    margin: 0;

    .swiper-container {
        width: 100%;
        height: 100%;
        padding-bottom: .65rem;
    }

    .swiper-slide {
        text-align: center;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;

        .swiper-slide__img-holder {
            width: 100%;

            img {
                object-fit: cover;
                width: 100%;
                height: 163px;
            }
        }
    }
}

.swiper-container-horizontal>.swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
    bottom: -1px;
}

.swiper-pagination-bullet-active {
    background: #9b9b9b;
}
</style>
